export default __webpack_public_path__ + "97d0c47387856eaafba87b56bf1ca402.glb";